import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Button } from 'system/atoms';
import { openingMessagesLaunchButtonsSx } from '../styles';

export type OpeningMessagesLaunchOption = 'now' | 'schedule' | 'doNotLaunch';

type Props = {
  onSelectOption: (option: OpeningMessagesLaunchOption) => void;
  disabled?: boolean;
};

export const OpeningMessagesLaunchButtons: React.FC<Props> = ({
  onSelectOption,
  disabled = false
}) => {
  return (
    <Box sx={openingMessagesLaunchButtonsSx.container}>
      <Tooltip
        title="Return to the campaign dashboard and launch when you're ready"
        arrow
        placement="top"
      >
        <span>
          <Button
            variant="tertiary"
            sx={openingMessagesLaunchButtonsSx.textButton}
            onClick={() => onSelectOption('doNotLaunch')}
            disabled={disabled}
          >
            Launch later
          </Button>
        </span>
      </Tooltip>
      <Button
        variant="secondary"
        sx={openingMessagesLaunchButtonsSx.outlinedButton}
        onClick={() => onSelectOption('schedule')}
        disabled={disabled}
      >
        Schedule launch
      </Button>
      <Button
        variant="primary"
        sx={openingMessagesLaunchButtonsSx.primaryButton}
        onClick={() => onSelectOption('now')}
        disabled={disabled}
      >
        Launch campaign now
      </Button>
    </Box>
  );
};
